// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"23a979a0","273":"23a979a0","359":"23a979a0","410":"e211175e","421":"4ae34765"}[chunkId] + ".chunk.css";
};